import {
  FilterType,
  buildDocumentsDataTableFilter,
  useDocumentsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import employees from 'modules/employees/store/collections/employees'

const employeeStatusFilter = (
  source: ReturnType<typeof useDocumentsDataTable>,
  currentEmployeeId: number,
  allMyDescendants: number[]
) => {
  const activeEmployees = employees
    .filter((employee) => !employee.isTerminated)
    .map((employee) => employee.id)
  const pastEmployees = employees
    .filter((employee) => employee.isTerminated)
    .map((employee) => employee.id)

  const reportingToMe = employees
    .filter((employee) => allMyDescendants.includes(employee.id))
    .map((employee) => employee.id)
  const reportingToMeDirectly = employees
    .filter((employee) => employee.attributes.manager_id === currentEmployeeId)
    .map((employee) => employee.id)

  const employeeStatusOptions = [
    {
      value: activeEmployees,
      label: i18n.t('documents.employee.filters.employee_status_options.active_employees'),
    },
    {
      value: pastEmployees,
      label: i18n.t('documents.employee.filters.employee_status_options.past_employees'),
    },
    {
      value: reportingToMeDirectly,
      label: i18n.t('documents.employee.filters.employee_status_options.report_direct'),
    },
    {
      value: reportingToMe,
      label: i18n.t('documents.employee.filters.employee_status_options.report_me'),
    },
  ]
  const options = employeeStatusOptions.filter(({ value }) => value.length > 0)

  return buildDocumentsDataTableFilter(source, {
    type: FilterType.Integer,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'employee_status',
    path: 'employeeStatus',
    title: i18n.t('documents.employee.filters.employee_status'),
  })
}

export default employeeStatusFilter
